import React from 'react'
import { Modal, Button } from 'antd'
import styles from './Package.module.scss'
import IconSuccessBig from 'assets/icons/icon_success_big.svg'
import { TranslateLanguage } from 'util/Translate'
import { vocabHome } from 'util/Translate.variable'


const translate = new TranslateLanguage()
translate.addMaping(vocabHome)

const ModalSuccess = (props) => {
  const {
    visible,
    setVisible,
    onOk = null,
    title = 'ยกเลิกแพ็กเกจสำเร็จ',
    setBody = 'ระบบได้ส่งอีเมลแจ้งเตือนไปยังอีเมลของคุณ \n กรุณาตรวจสอบอีเมล' } = props
  const onClose = () => setVisible(false)
  return (
    <Modal
      visible={visible}
      onCancel={onClose}
      footer={false}
      bodyStyle={{ padding: '32px 64px', width: '540px', height: '431px' }}
      centered
    >
      <div className={styles.modal_success}>
        <img alt='IconSuccessBig' src={IconSuccessBig} />
        <h4>{title}</h4>
        <span>{setBody && setBody.includes('\n') ? setBody.split('\n').map((value, i) => <p key={'p' + String(i)}> {value} </p>) : setBody} </span><br />
        <Button onClick={onOk ? onOk : onClose} type='primary'>ตกลง</Button>
      </div>
    </Modal>
  )
}
export default ModalSuccess